module.exports = __webpack_public_path__ + "img/a3.92b25753.png";